import BaseNormalizer from "./BaseNormalizer";

const productDraftNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "brand",
  "name",
  "option",
  "isBio",
  "isLactoseFree",
  "isGlutenFree",
  "generalInformation",
  "supplierItemNumber",
  "ean",
  "salesUnitId",
  "salesQuantity",
  "depositValue",
  "depositTypeId",
  "ageRestriction",
  "state",
  "lastWizardStep",
  "packagingId",
  "vatRate",
  "purchasePrice",
  "grossPrice",
  "thumbnailUri",
  "rejectionReason",
  "isSubjectToCooling",
  "isOfferingFreeSamples",
  "regulatedOrganicProductId",
  "dimensionLength",
  "dimensionWidth",
  "dimensionHeight",
  "weight",
  "alcoholContent",
  "minimumShelfLife",
  "categoryId",
  "imageIds",
  "certificateIds",
  "isEditable",
  "isSubmittable",
  "validationErrors",
  "hasStandardShippingUnit",
  "shippingUnits.id",
  "shippingUnits.state",
  "shippingUnits.name",
  "shippingUnits.gtin",
  "shippingUnits.promotionType",
  "shippingUnits.supplierItemNumber",
  "shippingUnits.purchasePrice",
  "shippingUnits.dimensionWidthCm",
  "shippingUnits.dimensionHeightCm",
  "shippingUnits.dimensionLengthCm",
  "shippingUnits.weightKg",
  "shippingUnits.weightExclPackagingKg",
  "shippingUnits.orderableFrom",
  "shippingUnits.orderableTo",
  "shippingUnits.packagingId",
  "shippingUnits.depositValue",
  "shippingUnits.depositTypeId",
  "shippingUnits.isEditable",
  "shippingUnits.isLive",
  "shippingUnits.imageId",
  "shippingUnits.thumbnailUri",
  "shippingUnits.rejectionReason",
  "shippingUnits.quantity",
]);

export default productDraftNormalizer;
